<template>
  <div>
    <i class="fa fa-check text-success"></i>
    Optioneel: voeg zelf extra vragen toe (€50 per vraag)
  </div>
</template>

<script>
export default {
  name: 'AddCustomQuestion',
};
</script>
